class TaskType {
    static Call() {
        return 1;
    }

    static Email() {
        return 2;
    }

    static Meeting() {
        return 3;
    }

    static Proposal() {
        return 4;
    }

    static Other() {
        return 5;
    }
}

// Builds the list of sales task type options from the admin-configurable "TaskType" parameter
// list (falls back to the original hardcoded five while parameters haven't loaded yet).
export const buildTaskTypeOptions = (configurableTaskTypes, t) => {
    if (configurableTaskTypes && configurableTaskTypes.length > 0) {
        return configurableTaskTypes.map((p) => ({ value: p.id, label: p.value }));
    }
    return [
        { value: TaskType.Call(), label: t('customer.leadTaskTypeCall') },
        { value: TaskType.Email(), label: t('customer.leadTaskTypeEmail') },
        { value: TaskType.Meeting(), label: t('customer.leadTaskTypeMeeting') },
        { value: TaskType.Proposal(), label: t('customer.leadTaskTypeProposal') },
        { value: TaskType.Other(), label: t('customer.leadTaskTypeOther') },
    ];
};

export default TaskType;
